module.exports = __webpack_public_path__ + "static/video-1-0966e00b1f7c262b4c0d66638e6e5a7a.mp4";